function getFormattedDate(date) {
    return date.toISOString().slice(0, 10);
}

function getNightsCount(checkIn, checkOut) {
    const checkInDate = new Date(checkIn).setHours(0, 0, 0, 0);
    const checkOutDate = new Date(checkOut).setHours(0, 0, 0, 0);

    return Math.round((checkOutDate - checkInDate) / (24 * 60 * 60 * 1000));
}

function hasEmptyDate(date) {
    return !date;
}

function hasEmptyDates(startDate, endDate) {
    return hasEmptyDate(startDate) && hasEmptyDate(endDate);
}

function hasEmptyDatesValues({startDate, endDate}) {
    return hasEmptyDates(startDate, endDate);
}

function hasFilledDate(date) {
    return !hasEmptyDate(date);
}

function hasFilledDates(startDate, endDate) {
    return hasFilledDate(startDate) && hasFilledDate(endDate);
}

/* istanbul ignore next */
function hasFilledDatesValues({startDate, endDate}) {
    return hasFilledDates(startDate, endDate);
}

function hasPartialDates(startDate, endDate) {
    return !hasEmptyDates(startDate, endDate) && !hasFilledDates(startDate, endDate);
}

/* istanbul ignore next */
function hasPartialDatesValues({startDate, endDate}) {
    return hasPartialDates(startDate, endDate);
}

function hasValidDate(date) {
    return hasFilledDate(date);
}

function hasValidDateRange(startDate, endDate) {
    const startTimestamp = Date.parse(startDate);
    const endTimestamp = Date.parse(endDate);

    const todayDate = getFormattedDate(new Date());
    const todayTimestamp = Date.parse(todayDate);

    return (
        startTimestamp >= todayTimestamp &&
        startTimestamp < endTimestamp
    );
}

function hasValidDates(startDate, endDate) {
    return hasValidDate(startDate) && hasValidDate(endDate) && hasValidDateRange(startDate, endDate);
}

function hasValidDatesValues({startDate, endDate}) {
    return hasValidDates(startDate, endDate);
}

function showDatesInputFieldError(media, dates) {
    const {
        settings: {
            isMobile
        }
    } = media;

    const {
        options: {
            allowErrorHighlighting
        },
        latestValues
    } = dates;

    return !isMobile && allowErrorHighlighting && !hasValidDatesValues(latestValues);
}

export {
    getFormattedDate,
    getNightsCount,
    hasEmptyDate,
    hasEmptyDates,
    hasEmptyDatesValues,
    hasFilledDate,
    hasFilledDates,
    hasFilledDatesValues,
    hasPartialDates,
    hasPartialDatesValues,
    hasValidDate,
    hasValidDateRange,
    hasValidDates,
    hasValidDatesValues,
    showDatesInputFieldError
};
